<div class="d-flex flex-column align-items-center justify-content-center"
    style="min-height: 400px;">
    <svg-icon src="assets/images/icon-search.svg"
        style="font-size: 64px; color: #ccc; margin-bottom: 24px;"></svg-icon>
    <span
        style="font-size: 18px; font-weight: 500; color: #666; margin-bottom: 8px;">
        Selecione versão para comparação
    </span>
    <span style="font-size: 14px; color: #999; text-align: center;">
        As diferenças serão destacadas para facilitar a análise
        das alterações.
    </span>
</div>